export default __webpack_public_path__ + "static/activities_image_five_mobile-bd28dfd040109e7443cf2571daaea80f.jpg";